import axios from 'axios'
import toast from 'react-hot-toast'
import { getRefreshToken } from '@/services/api/(auth)/token/refresh'
import { AxiosDefaultOptions } from '@/services/config'
import { clearAuthSlice, getAuthSliceSync, setAuthSlice } from '@/store/slices/auth'

const apiClient = axios.create(AxiosDefaultOptions)

apiClient.interceptors.request.use(config => {
  const { accessToken } = getAuthSliceSync()
  config.headers.set('Authorization', `Bearer ${accessToken || ''}`)
  return config
})

apiClient.interceptors.response.use(
  response => response,
  async error => {
    if (error?.response?.status !== 401) return Promise.reject(error)

    const { accessToken, refreshToken } = getAuthSliceSync()

    try {
      const { data } = await getRefreshToken({ accessToken, refreshToken })
      if (data) {
        await setAuthSlice({
          accessToken: data?.data?.authorization?.access_token,
          refreshToken: data?.data?.authorization?.refresh_token,
        })
        error.config.headers.set('Authorization', `Bearer ${data?.data?.authorization?.access_token}`)
      }

      return axios(error.config)
    } catch (e) {
      await clearAuthSlice()
      toast.error('Your session has expired. Please log in again.')
      setTimeout(() => window?.location.replace('/login'), 1200)
      return Promise.reject(e)
    }
  },
)

export { apiClient }
